import { matchRoutes } from "react-router-dom";
import { routes } from "../../routes";

/**
 * Return route loader params and pathname for a matched route.
 *
 * @param path - The URL path to match against the application routes.
 * @returns An object containing `params` and `pathname` from the matched route loader, or `undefined`.
 */
export const getRouteLoaderParams = (path: string) => {
  return matchRoutes(routes, path)
    ?.filter((match) => match.route.loader)
    .map((m) => ({ params: m.params, pathname: m.pathname }))
    .pop();
};
